<div *ngFor="let input of inputs" class="input" [ngClass]="{ 'first-input': input?.inputType === 'address' }">
  
  <ng-container *ngIf="input.inputType === 'checkbox'">
    <div class="margin-vertical mv8">
      <input class="single-checkbox {{input.additionalClasses}}" [id]="input.key"  type="checkbox" [formControlName]="input?.key">
      <label class="margin-left ml16" [for]="input.key">{{ input.label | translate }}</label>
    </div>
  </ng-container>

  <ng-container *ngIf="input.inputType === 'button'">
    <mapfre-button [input]="input" [form]="form"></mapfre-button>
  </ng-container>

  <ng-container *ngIf="input.inputType !== 'checkbox' && input.inputType !== 'button' ">
    <mapfre-validation [input]="input" [form]="form"></mapfre-validation>
  </ng-container>
 
</div>
